<template>
  <div>
    <div class="application10">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application10-1.jpg" alt />
          <img src="../../assets/images/application/application10-2.jpg" alt />
          <img src="../../assets/images/application/application10-3.jpg" alt />
          <img src="../../assets/images/application/application10-4.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application10">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>{{ a.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>{{ b.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 4" :key="index">
              <img :src="getImg(`application10-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application10",
  metaInfo: {
    title:
      "智慧港口可视化管理_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "智慧港口,智慧码头,三维港口,三维码头,港口三维GIS,港口可视化"
      },
      {
        name: "description",
        content:
          "基于二三维GIS、BIM、物联网技术实现港口区域环境和设备设施的二三维可视化一张图,物联网设备信息数据集成,实现船舶管理、泊位管理、货物监管、人员监管、考勤管理、告警管理、视频监控、无人机管理等功能。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧港口可视化管理",
        p:
          "基于二三维GIS、BIM、物联网技术实现港口区域环境和设备设施的二三维可视化一张图，物联网设备信息数据集成，实现船舶管理、泊位管理、货物监管、人员监管、考勤……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p: "智慧港口、智慧码头信息化应用。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "基于二三维GIS、BIM、物联网技术实现港口区域环境和设备设施的二三维可视化一张图，物联网设备信息数据集成，实现船舶管理、泊位管理、货物监管、人员监管、考勤管理、告警管理、视频监控、无人机管理等功能。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application10 {
  font-size: 0;
  img {
    width: 584px;
    margin-top: 20px;
    &:nth-child(2n + 1) {
      margin-right: 20px;
    }
  }
}
.mobile-application10 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application10 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application10 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application10.vue